import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProfileService } from '../profile/profile.service';
import { PROFILE_STAGES } from '../profile/types/profile-stages.model';
import { ProfileTracker, PROFILE_TRACKER_STAGE_STATUS } from '../profile/types/profile-tracker.model';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(public auth: AuthService, public router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
        // Store the attempted URL for redirecting
        this.auth.redirectUrl = url;
        // If user is not authenticated, send to login page
        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['/login']);
            return false;
        }
        return true;
    }
}